<section class="!flex !flex-col !gap-4 !overflow-hidden !rounded-2xl !border !border-solid !border-border !bg-white !p-5 sm:!flex-row sm:!items-center sm:!gap-5 sm:!p-6"
         aria-labelledby="company-identity-name">
    <label class="!relative !m-0 !block !h-16 !w-16 !shrink-0 !cursor-pointer sm:!h-20 sm:!w-20"
           [attr.aria-label]="'Cambia logo di ' + (company.name || 'società')">
        <img class="!h-16 !w-16 !rounded-2xl !border !border-solid !border-slate-200 !bg-slate-50 !object-cover sm:!h-20 sm:!w-20"
             [src]="company.logoUrl || 'assets/profilePic.png'"
             [alt]="company.name ? 'Logo ' + company.name : 'Logo società'"/>
        <span class="!absolute !-right-1 !-top-1 !grid !h-7 !w-7 !place-items-center !rounded-full !border !border-solid !border-slate-200 !bg-white !text-xs !text-slate-500 !shadow-sm">
            <i class="bi bi-pencil-fill" aria-hidden="true"></i>
        </span>
        <input type="file" accept=".png,.jpg,.jpeg" class="d-none" (change)="logoChange.emit($event)"/>
    </label>

    <div class="!min-w-0 !flex-1">
        <div class="!flex !flex-wrap !items-center !gap-x-3 !gap-y-2">
            <h2 id="company-identity-name" class="!mb-0 !text-xl !font-extrabold !leading-tight !tracking-tight !text-strong">
                {{ company.name || 'Società senza ragione sociale' }}
            </h2>
            <app-companies-settings-status-badge [status]="company.status"></app-companies-settings-status-badge>
            <app-companies-settings-status-badge *ngIf="isSuperAdmin" [meta]="subscriptionMeta"></app-companies-settings-status-badge>
        </div>
        <p class="!mb-0 !mt-1.5 !text-sm !leading-relaxed !text-subtle" *ngIf="fiscalLine || locationLine || company.companyEmail">
            <span *ngIf="fiscalLine">{{ fiscalLine }}</span>
            <span *ngIf="fiscalLine && locationLine" class="!px-1.5" aria-hidden="true">·</span>
            <span *ngIf="locationLine">{{ locationLine }}</span>
            <span *ngIf="(fiscalLine || locationLine) && company.companyEmail" class="!px-1.5" aria-hidden="true">·</span>
            <span *ngIf="company.companyEmail">{{ company.companyEmail }}</span>
        </p>
        <div *ngIf="isSuperAdmin && company.id"
             class="!mt-3 !inline-flex !max-w-full !items-center !gap-2 !rounded-lg !border !border-dashed !border-slate-200 !bg-slate-50 !px-2.5 !py-1">
            <span class="!text-[11px] !font-bold !uppercase !tracking-wide !text-slate-400">ID</span>
            <code class="!max-w-[14rem] !truncate !text-xs !text-slate-700 sm:!max-w-none">{{ company.id }}</code>
            <button type="button"
                    class="!m-0 !inline-flex !h-6 !w-6 !items-center !justify-center !rounded-md !border-0 !bg-transparent !p-0 !text-slate-400 hover:!bg-white hover:!text-slate-700"
                    (click)="onCopyId()"
                    aria-label="Copia ID società">
                <i class="bi bi-clipboard" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</section>
